import methodHelpers from 'src/utilities/method-helpers';
import { DateTime } from 'luxon';
import SvgIcon from 'src/react_components/svg-icon';
import * as copy from 'copy-to-clipboard';
import { QAOverviewProps } from '../types.d';

const QAOverview = ({ active, ...rest }: QAOverviewProps) => {
  const formatDateTime = (datetime: string) => (datetime ? DateTime.fromISO(datetime).
    toFormat('d MMM yyyy hh:mma') : '');
  const toBooleanText = (value: boolean) => (value ? 'True' : 'False');
  const acceptedByQA = formatDateTime(rest?.qa_accepted_at);
  const startTime = formatDateTime(rest?.started_at);
  const reasonsForReview = rest?.reasons_for_review?.join(', ');
  const rating = {
    1: 'Extremely dissatisfied',
    2: 'Somewhat dissatisfied',
    3: 'Neither satisfied nor dissatisfied',
    4: 'Somewhat satisfied',
    5: 'Extremely satisfied'
  };
  const overviews = [
    {
      label: 'QA Information',
      key: 'qa-information',
      infos: [
        { label: 'Accepted by QA', value: acceptedByQA },
        { label: 'Session start time', value: startTime },
        { label: 'Reason for review', value: reasonsForReview },
        { label: 'Student Name', value: rest?.student_name },
        { label: 'Client Name', value: rest?.client_name },
        { label: 'Client Language', value: rest?.language }
      ]
    },
    {
      label: 'Student Feedback',
      key: 'student-feedback',
      infos: [
        { label: 'Student comment', value: rest?.student_comment || 'N/A', type: 'quote' },
        {
          label: 'Student rating',
          value: rating[rest?.student_rating] || 'N/A',
          valueClassName: `rating-${rest?.student_rating}`
        },
        { label: 'Feel more confident', value: toBooleanText(rest?.more_confident) },
        { label: 'Received help', value: toBooleanText(rest?.receive_help) },
        { label: 'Easy to use', value: toBooleanText(rest?.easy_to_use) }
      ]
    },
    {
      label: 'Session Information',
      key: 'session-information',
      infos: [
        { label: 'Total messages', value: rest?.messages_count },
        { label: 'Partner resources provided', value: rest?.client_resources?.join(', ') }
      ]
    }
  ];

  const session = {
    title: 'Session URL',
    url: rest?.session_url,
    uuid: rest?.uuid
  };

  const className = methodHelpers.buildClassNames({
    active,
    'tab-content': true,
    'u-marginVLg my-4': true
  });
  return (
    <div className={className}>
      {overviews.map((section) => (
        <div key={section.label} className={`overview-${section.key}`}>
          <p className="section-title">{section.label}</p>
          <div className="u-flex u-flexCol d-flex flex-column gap-2 u-marginVLg my-4">
            {
              section.infos.map(({
                label, value, type, valueClassName
              }) => (
                <div className="row row-cols-2" key={label}>
                  <h5 className="u-marginNone m-0">{label}</h5>
                  {
                    type === 'quote' ? <i><q className={valueClassName}>{value}</q></i> :
                    <div className={valueClassName}>{value}</div>
                  }
                </div>
              ))
            }
          </div>
        </div>
      ))}
      <hr className="u-marginVXl my-5" />
      <section className="overview-session-url text-muted right-buffer-tall-lg">
        <div className="overview-session-url__title">
          <strong>{session.title}</strong>
        </div>
        <div className="overview-session-url__content">
          <span>{session.uuid}</span>
          <button
            type="button"
            className="btn-link copy-url"
            onClick={() => copy(session.url)}
          >
            <SvgIcon className="icon-sm valign-middle" icon="content_copy" />
          </button>
        </div>
      </section>
    </div>
  );
};

export default QAOverview;
